<div *ngIf="action !== 'comments'"
     class="tab-buttons-container"
     [class.with-quote]="quote"
     [class.without-quote]="!quote">

  <button *ngFor="let tab of tabs"
          class="tab-button"
          [class.active]="activeTab === tab.id"
          [disabled]="tab.disabled"
          [ngStyle]="{
                      'color': activeTab === tab.id ? buttonColorActive : buttonTextActive,
                      'font-size': categoryId === 8 ? '18px' : '14px',
                      'font-weight': categoryId === 8 ? '600' : '500'
          }"
          (click)="onTabClick(tab)">

    <ng-container *ngIf="tab.icon; else noIcon">
      <img [src]="tab.icon" class="tab-icon" [alt]="tab.label">
    </ng-container>
    <ng-template #noIcon>
      {{ tab.label }}
    </ng-template>

  </button>
</div>
